<div class="status_history">
	<div class="status_history-header">
		<span i18n="@@orders.order_status_history">Order Status History</span>
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
			<path
				d="M7.99992 15.1668C11.6818 15.1668 14.6666 12.1821 14.6666 8.50016C14.6666 4.81826 11.6818 1.8335 7.99992 1.8335C4.31802 1.8335 1.33325 4.81826 1.33325 8.50016C1.33325 12.1821 4.31802 15.1668 7.99992 15.1668Z"
				stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M8 11.1667V8.5" stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M8 5.8335H8.00667" stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</div>
	<div class="status_history-title" *ngIf="order.delivery_with != 'oto'; else otoOrder">
		<ng-container *ngFor="let status of getStatusesToDisplay()" >
			<div class="status_type">
				<div class="order_{{ status }} order_status" attr.data-status="{{ status }}" [style.opacity]="!getDateTime(status) ? 0.5 : 1">
					<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
						<circle cx="4" cy="4" r="4" fill="#18F121" />
					</svg>
					{{ status | titlecase | removeUnderscore }}
				</div>
				<span class="">{{ getDateTime(status) | date:"MMM dd, hh:mm a" }}</span>
			</div>
			<div class="horizontal_line" *ngIf="!endStatuses.includes(status)"></div>
		</ng-container>
	</div>
	<ng-template #otoOrder>
		<div class="status_history-title" *ngIf="order.delivery_with == 'oto'">
			<ng-container *ngFor="let status of possibleStatuses" >
				<div class="status_type">
					<div class="order_{{ status }} order_status" attr.data-status="{{ status }}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121" />
						</svg>
						{{ status.status | titlecase | removeUnderscore }}
					</div>
					<span class="">{{ status?.date | date:"MMM dd, hh:mm a" }}</span>
				</div>
				<div class="horizontal_line" *ngIf="!endStatuses.includes(status)"></div>
			</ng-container>
		</div>
	</ng-template>
	<!-- <div class="status_history-title">
		<div class="status_type">
			<div class="order_new order_status" data-status="new" [ngStyle]="{opacity: '1'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
				</svg>
				New
			</div>
			<span class="">Today 03:30 PM</span>
		</div>
		<div class="horizontal_line"></div>
		<div class="status_type">
			<div class="order_preparing order_status" data-status="preparing" [ngStyle]="{opacity: '0.5'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
				</svg>
				Preparing
			</div>
			<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
		</div>
		<div class="horizontal_line"></div>
		<div class="status_type">
			<div class="order_paid order_status" data-status="paid" [ngStyle]="{opacity: '0.5'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
				</svg>
				Paid
			</div>
			<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
		</div>
		<div class="horizontal_line"></div>
		<div class="status_type">
			<div class="order_delivery order_status" data-status="delivery" [ngStyle]="{opacity: '0.5'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
				</svg>
				Delivery
			</div>
			<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
		</div>
		<div class="horizontal_line"></div>
		<div class="status_type">
			<div class="order_complete order_status" data-status="complete" [ngStyle]="{opacity: '0.5'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
				</svg>
				Complete
			</div>
			<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
		</div>
	</div> -->
</div>